const quantitySelector = {
  getInput(el) {
    const parent = el.closest('[data-quantity-selector]')
    if (!parent) return
    const input = parent.querySelector('input[type=number]')
    if (!input) return
    return input
  },
  decreaseQuantity(event) {
    const input = this.getInput(event.target)
    const parent = input.closest('[data-quantity-selector]')
    const maxValue = input.getAttribute('max') ? parseInt(input.getAttribute('max')) : false

    if (!input) return
    const value = parseInt(input.value)
    input.value = value > 1 ? value - 1 : 1

    if (maxValue !== false && input.value < maxValue) {
      parent.querySelector('[data-increase-quantity]').disabled = false
      parent.querySelector('[data-increase-quantity]').removeAttribute('disabled')
    }
  },
  increaseQuantity(event) {
    const input = this.getInput(event.target)
    const parent = input.closest('[data-quantity-selector]')

    if (!input) return
    const maxValue = input.getAttribute('max') ? parseInt(input.getAttribute('max')) : false
    const value = parseInt(input.value)
    input.value = (maxValue !== false && value >= maxValue) ? maxValue : value + 1

    if (maxValue !== false && input.value >= maxValue) {
      parent.querySelector('[data-increase-quantity]').disabled = true
    }
  },
  validate(event) {
    const input = event.target
    const parent = input.closest('[data-quantity-selector]')
    const maxValue = input.getAttribute('max') ? parseInt(input.getAttribute('max')) : false
    const value = parseInt(input.value)
    if (value < 1 || Number.isNaN(value)) input.value = 1
    else if (maxValue !== false && value > maxValue) input.value = maxValue
    else input.value = value

    if (maxValue !== false) {
      if (input.value >= maxValue) {
        parent.querySelector('[data-increase-quantity]').disabled = true
      } else {
        parent.querySelector('[data-increase-quantity]').disabled = false
        parent.querySelector('[data-increase-quantity]').removeAttribute('disabled')
      }
    }
  }
}

export default quantitySelector
